import { render, staticRenderFns } from "./CctvPage.vue?vue&type=template&id=61f66501&scoped=true"
import script from "./CctvPage.vue?vue&type=script&lang=js"
export * from "./CctvPage.vue?vue&type=script&lang=js"
import style0 from "./CctvPage.vue?vue&type=style&index=0&id=61f66501&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f66501",
  null
  
)

export default component.exports